module.exports = __webpack_public_path__ + "static/media/product-onoake-detail.958fc4b4.png";